export default __webpack_public_path__ + "static/media/trr-event-music-live.29938443.png";